import React, { forwardRef, memo, ForwardedRef } from 'react';
import styled from 'styled-components';
import Button from 'components/Button/Button';
import { gridConfig } from '@tvg/fuse-design';

const Container = styled.div`
  margin-bottom: var(--spacing-space12);

  @media (max-width: ${gridConfig.l.minWidth}) {
    margin-top: var(--spacing-space4);
  }
`;

interface Props {
  handleAddToBasket: () => void;
  disabled: boolean;
  updateBasket?: boolean;
}

const AddToBasketButton = forwardRef(
  ({ handleAddToBasket, disabled, updateBasket = false }: Props, ref: ForwardedRef<HTMLDivElement>) => (
    <Container ref={ref}>
      <Button
        id="primaryAddToBasket"
        onClick={() => handleAddToBasket()}
        data-testid="add_to_basket_button"
        disabled={disabled}
        data-transaction-name={updateBasket ? 'UpdateBasket' : 'AddToBasket'}
      >
        {updateBasket ? 'Update basket' : 'Add to basket'}
      </Button>
    </Container>
  ),
);

export default memo(AddToBasketButton);
